import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortDetailsService } from 'src/app/shared/service/port-details/port-details.service';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { Subscription, interval, map, switchMap } from 'rxjs';
import {
  getConditionOptions,
  getSegmentOptions,
} from 'src/app/shared/helpers/Drop-down-options';
import { MatSort, Sort } from '@angular/material/sort';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-current-voyages',
  templateUrl: './current-voyages.component.html',
  styleUrls: ['./current-voyages.component.scss'],
})
export class CurrentVoyagesComponent implements OnInit {
  addRowdData: any[] = [];
  tableData: any[] = [];
  rowData: any = {};
  items = ['Ballast', 'Laden'];
  condition: any;
  segmentOptions: any;
  MerakiPicOptions = [
    'ALS',
    'ANKU',
    'HAJ',
    'HAS',
    'KER',
    'INV',
    'MAL',
    'PHJ',
    'PRA',
    'RAS',
    'SAG',
    'SOS',
    'SUTH',
    'BHY',
    'NAB',
    'DEKA',
    'ARYA',
    'HRIT',
    'NIMA',
  ];
  eigerPicOptions = [
    'SAKA',
    'SABA',
    'ROAK',
    'AAHA',
    'NIAL',
    'RAPA',
    'AHKM',
    'SAMH',
    'ALYI',
    'KHGL',
  ];
  customerOptions: any[] = [];
  portNameSuggestions: any[] = [];
  allPortData: any;
  filteredPortNames: any[] = [];
  filteredCustomerNames: any[] = ['Eiger'];
  selectedHour: number = 0;
  selectedMinute: number = 0;
  lastTableDataRowIndex: number = 0;
  updateForm!: FormGroup;
  itemsPerPage: number = 100;
  currentPage: number = 0;
  paginatedData: any[] = [];
  mapViewVisible: boolean = false;
  userName: any;
  refreshSubscription!: Subscription;
  @ViewChild(MatSort) sort!: MatSort;
  data: any;
  shipNameSuggestions: any[] = [];
  eigerUser: boolean = false;
  showFlash = false;
  showToast = false;
  constructor(
    private portDetails: PortDetailsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private sharedDataService: DashboardService,
    private router: Router,
    private dialog: MatDialog,
    private requestFormService: RequestFormService
  ) {
    this.updateForm = this.fb.group({
      from_date: [''],
      to_date: [''],
      condition: [''],
      segment: [''],
      shipName: [''],
    });
    this.segmentOptions = getSegmentOptions();
    this.condition = getConditionOptions();
  }

  ngOnInit() {
    if (localStorage.getItem('mapView') === 'true') {
      this.mapViewVisible = true;
    }
    this.loadPortDetailsAndData();
    this.userName = localStorage.getItem('username');
    this.startAutoRefresh();
  }
  startAutoRefresh() {
    this.refreshSubscription = interval(3600000).subscribe(() => {
      this.loadPortDetailsAndData();
    });
  }
  refresh() {
    this.paginatedData = [];
    this.loadPortDetailsAndData();
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  ngOnDestroy() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
  removeShipPrefix(shipName: string): string {
    if (!shipName) {
      return '';
    }

    // Remove known prefixes
    const cleanedName = shipName.replace(/^(MV|MT)\s*/i, '');

    // Capitalize first letter, rest lowercase
    return cleanedName
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  loadPortDetailsAndData() {
    this.loadPortDetails()
      .pipe(switchMap(() => this.loadData()))
      .subscribe(() => {
        this.lastTableDataRowIndex = this.tableData.length;
        this.filterClick();
      });
  }

  loadPortDetails() {
    return this.portDetails.getPortDetails().pipe(
      map((response: any) => {
        this.filteredPortNames = response?.data ?? [];
      })
    );
  }

  loadData() {
    return this.requestFormService.getReports().pipe(
      map((data: any) => {
        const selectedRadio = localStorage.getItem('selectedRadio');
        if (selectedRadio === 'myShips') {
          const selectedOperator = localStorage.getItem('selectedOperator');
          this.data = data.filter(
            (item: any) => item.eigerpic === selectedOperator
          );
        } else {
          this.data = data;
        }
        const modifiedData = this.data.map((element: any) => {
          element.ship = this.removeShipPrefix(element.ship);
          element.flag = this.getRedFlagString(element);
          return element;
        });
        this.tableData = modifiedData.filter(
          (element: any) => element.status !== 'True'
        );

        this.paginateData();
        console.log(data);
      })
    );
  }
  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.shipNameSuggestions = this.data.filter((item: any) =>
        item.ship.toLowerCase().includes(inputValue)
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  toggleMapView() {
    this.mapViewVisible = !this.mapViewVisible;
    localStorage.removeItem('mapView');
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.tableData?.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }
  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, sort.active, isAsc);
    });
  }

  compare(a: any, b: any, sortActive: string, isAsc: boolean) {
    if (sortActive === 'etaDate') {
      const dateA = a[sortActive] || '';
      const dateB = b[sortActive] || '';

      // Handle "null 00:00" → push to last
      const isNullA = dateA.startsWith('null');
      const isNullB = dateB.startsWith('null');

      if (isNullA && !isNullB) return 1; // A is null → goes last
      if (!isNullA && isNullB) return -1; // B is null → goes last
      if (isNullA && isNullB) return 0; // both null → treat as equal

      // Normal string compare (since format is YYYY-MM-DD HH:mm)
      return dateA.localeCompare(dateB) * (isAsc ? 1 : -1);
    }
    if (sortActive === 'updatedAt') {
      const dateA = a['updatedAt'] ? new Date(a['updatedAt']).getTime() : 0;
      const dateB = b['updatedAt'] ? new Date(b['updatedAt']).getTime() : 0;

      return (dateA - dateB) * (isAsc ? 1 : -1);
    }
    if (sortActive === 'flag') {
      return a[sortActive].localeCompare(b[sortActive]) * (isAsc ? 1 : -1);
    }

    if (a === null || a === undefined) return isAsc ? -1 : 1;
    if (b === null || b === undefined) return isAsc ? 1 : -1;

    const aNum = parseFloat(a[sortActive]);
    const bNum = parseFloat(b[sortActive]);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return (aNum < bNum ? -1 : 1) * (isAsc ? 1 : -1);
    }

    if (
      typeof a[sortActive] === 'string' &&
      typeof b[sortActive] === 'string'
    ) {
      return a[sortActive].localeCompare(b[sortActive]) * (isAsc ? 1 : -1);
    }

    return (a[sortActive] < b[sortActive] ? -1 : 1) * (isAsc ? 1 : -1);
  }
  getRedFlagString(res: any) {
    const isVoyAvgSpeedValid =
      res.voyAvgSpeed !== null &&
      res.voyAvgSpeed !== '' &&
      res.voyAvgSpeed !== undefined;
    let showRedFlag = false;

    if (
      res.voyAvgSpeed === null ||
      res.voyAvgSpeed === undefined ||
      res.voyAvgSpeed === ''
    ) {
      return 'Gray Flag';
    } else if (isVoyAvgSpeedValid) {
      const difference = res.cpOrderedSpeed - res.voyAvgSpeed;
      showRedFlag = difference > 0.5;
      return showRedFlag ? 'Red Flag' : 'No Flag';
    } else {
      return 'No Flag';
    }
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  addRow() {
    if (this.userName === 'Eiger Shipping') {
      this.eigerUser = true;
    } else {
      const newRowSNo = this.tableData.length + 1;
      this.addRowdData.push({ sNo: newRowSNo });
    }
  }
  clearClick() {
    this.updateForm.reset();
    this.paginateData();
  }
  restrictInput(inputField: any, maxAllowed: any) {
    inputField.value = inputField.value.replace(/^0+/, '');
    if (parseInt(inputField.value) > maxAllowed) {
      inputField.value = maxAllowed;
    }
    if (inputField.value.length === 1) {
      inputField.value = '0' + inputField.value;
    }
  }
  filterClick() {
    const from_date_str = this.updateForm.get('from_date')?.value;
    const to_date_str = this.updateForm.get('to_date')?.value;
    const segment = this.updateForm.get('segment')?.value;
    const condition = this.updateForm.get('condition')?.value;
    const shipName = this.updateForm.get('shipName')?.value;
    const data = this.tableData?.filter(
      (element: any) => element.status !== 'True'
    );

    const filteredData = data.filter((element: any) => {
      const fromDateValid =
        !from_date_str || element.updatedAt >= from_date_str;
      const toDateValid = !to_date_str || element.updatedAt <= to_date_str;
      const segmentValid =
        !segment || element.segment?.toLowerCase() === segment.toLowerCase();
      const conditionValid =
        !condition ||
        element.voyageType?.toLowerCase() === condition.toLowerCase();
      const shipNameFilter =
        !shipName ||
        element.ship?.toLowerCase().includes(shipName.toLowerCase());

      return (
        fromDateValid &&
        toDateValid &&
        segmentValid &&
        conditionValid &&
        shipNameFilter
      );
    });
    this.paginatedData = filteredData.slice(0, this.itemsPerPage);
    this.currentPage = 0;
  }

  saveData() {
    if (this.addRowdData.every((row) => this.isRowDataValid(row))) {
      if (this.addRowdData.length > 0) {
        this.addRowdData.forEach((row) => {
          row.etaDate = `${row.etaDate} ${('0' + row.etaHours).slice(-2)}:${(
            '0' + row.etaMinutes
          ).slice(-2)}`;
        });
        this.requestFormService.postFormDetails(this.addRowdData[0]).subscribe(
          (data) => {},
          (error) => {
            if (error.error.text === 'save_button_success') {
              this.addRowdData = [];
              this.paginatedData = [];
              this.loadPortDetailsAndData();
            } else {
              this.toastr.error(ToasterMessages.Error);
            }
          }
        );
      }
    } else {
      this.toastr.info('Please fill in all fields before saving.');
    }
  }
  isRowDataValid(row: any): boolean {
    return (
      row.ship &&
      row.customername &&
      row.segment &&
      row.pFrom &&
      row.pTo &&
      row.voyageType &&
      row.cpOrderedSpeed
    );
  }
  formatDate(dateString: any) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    if (isNaN(year) || isNaN(date.getMonth()) || isNaN(date.getDate())) {
      return 'NA';
    }
    return `${year}-${month}-${day}`;
  }
  formatTime(dateString: any) {
    if (!dateString) return '';
    const dateParts = dateString.split(' ');
    if (dateParts.length < 2) return '';
    const time = dateParts[1];
    const timeParts = time.split(':');
    if (timeParts.length !== 2) return '';
    const hours = String(parseInt(timeParts[0], 10)).padStart(2, '0');
    const minutes = String(parseInt(timeParts[1], 10)).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  convertToUTC(updatedAtString: any) {
    if (!updatedAtString) return '';
    const date = new Date(updatedAtString);
    if (isNaN(date.getTime())) return '';
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
  deleteRow() {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '460px',
      height: '300px',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.addRowdData = this.addRowdData.filter((row) => !row.selected);
        const id = this.selectedRow.id;
        if (id) {
          this.requestFormService.deleteRow(id).subscribe(
            (data) => {
              console.log(data, 'delete............');
            },
            (error) => {
              if (error.error.text === 'record delete successfully') {
                this.paginatedData = [];
                this.loadPortDetailsAndData();
                this.toastr.success('Record Deleted successfully');
              } else {
                this.toastr.error(ToasterMessages.Error);
              }
            }
          );
        }
      } else {
      }
    });
  }
  filterPortNames(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();

    if (this.filteredPortNames && event) {
      this.portNameSuggestions = this.filteredPortNames.filter(
        (suggestion: any) =>
          suggestion.port_name.toLowerCase().startsWith(filterValue) ||
          suggestion.country.toLowerCase().startsWith(filterValue)
      );
      if (this.portNameSuggestions.length === 0) {
        this.portNameSuggestions = [];
      }
    } else {
      this.portNameSuggestions = [];
    }
  }
  filterCustomerNames(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (this.filteredCustomerNames && event) {
      this.customerOptions = this.filteredCustomerNames.filter(
        (suggestion: any) => suggestion.toLowerCase().startsWith(filterValue)
      );
    }
  }

  validateHour() {
    if (this.selectedHour > 23) {
      this.selectedHour = 23;
    } else if (this.selectedHour < 0) {
      this.selectedHour = 0;
    }
  }

  onKeyDown(event: KeyboardEvent, validateTo: number, element: any) {
    const isNumericKey = event.key >= '0' && event.key <= '9';
    if (!isNumericKey) {
      return;
    }
    if (isNumericKey) {
      const inputValue = parseInt(
        (<HTMLInputElement>event.target).value + event.key
      );
      if (inputValue < 0 || inputValue > validateTo) {
        event.preventDefault();
      }
    }
  }

  convertEtaHoursDigit(element: any) {
    if (parseInt(element.etaHours) < 0 || parseInt(element.etaHours) > 24) {
      element.etaHours = '';
    } else {
      if (element.etaHours.length === 1) {
        element.etaHours = '0' + element.etaHours;
      } else {
        if (parseInt(element.etaHours) < 0 || parseInt(element.etaHours) > 24) {
          element.etaHours = '';
        } else {
          element.etaHours =
            element.etaHours.length == 3
              ? parseInt(element.etaHours)
              : element.etaHours;
        }
      }
    }
  }

  validateMinute() {
    if (this.selectedMinute > 59) {
      this.selectedMinute = 59;
    } else if (this.selectedMinute < 0) {
      this.selectedMinute = 0;
    }
  }
  exportClick() {
    let csvContent = 'data:text/csv;charset=utf-8,';
    const headerRow = [
      'Ship Name',
      'Customer Name',
      'Segment',
      'Meraki Pic',
      'From',
      'To',
      'ETA(LT)',
      'Condition',
      'CP Speed',
      'Time Updated(UTC)',
    ].join(',');
    csvContent += headerRow + '\r\n';
    this.tableData.forEach((row) => {
      const values = [
        row.ship,
        row.customername,
        row.segment,
        row.merakiPic,
        row.pFrom,
        row.pTo,
        row.etaDate,
        row.voyageType,
        row.cpOrderedSpeed,
        this.convertToUTC(row.updatedAt),
      ];
      const csvRow = values
        .map((value) => {
          if (value && typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
          }
          return value;
        })
        .join(',');
      csvContent += csvRow + '\r\n';
    });
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Current_Voyages.csv');
    document.body.appendChild(link);
    link.click();
  }
  editRow(rowData: any) {
    this.sharedDataService.setFleetViewRowDat(rowData);
    this.router.navigate(['/vp-requestForm']);
  }
  selectedRow: any;

  isRowSnoozed(row: any): boolean {
    return !!row.status;
  }

  selectRow(row: any) {
    if (row) {
      this.selectedRow = row;
    }
  }

  isAnyRowSelected(): boolean {
    return this.tableData.some((row) => row.selected);
  }

  snoozeSelectedRow() {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '30%',
      height: '40%',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (this.isAnyRowSelected()) {
          this.paginatedData.forEach((row) => {
            if (row.selected) {
              row.status = true;
              row.client = row.client_name;
              row.selected = false;
              this.requestFormService.postFormDetails(row).subscribe(
                (data: any) => {},
                (error) => {
                  if (error.error.text === 'save_button_success') {
                    this.toastr.success('Record Snoozed successfully');
                    this.paginatedData = [];
                    this.loadPortDetailsAndData();
                  } else {
                    this.toastr.error(ToasterMessages.Error);
                  }
                }
              );
            }
          });
        }
      } else {
      }
    });
  }

  isMoreThan30HoursOld(dateString: string): boolean {
    const currentTime = new Date();
    const updatedTime = new Date(dateString);
    const timeDifference = currentTime.getTime() - updatedTime.getTime();
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return this.userName === 'Meraki - Operations' && hoursDifference > 30;
  }

  convertToDegreeDirection(value: any, isLatitude: boolean): string {
    if (value === null || value === undefined || value === '') {
      return 'NA';
    }
    const absoluteValue = Math.abs(value);
    const degrees = Math.floor(absoluteValue);
    const minutes = Math.floor((absoluteValue - degrees) * 60);
    const seconds = Math.round(((absoluteValue - degrees) * 60 - minutes) * 60);

    let direction = '';
    if (isLatitude) {
      direction = value >= 0 ? 'N' : 'S';
    } else {
      direction = value >= 0 ? 'E' : 'W';
    }

    return `${degrees}° ${minutes}' ${direction}`;
  }

  onPicChange(element: any) {
    element.client = element.client_name;
    element.eigerPic = element.eigerpic;
    this.requestFormService.postFormDetails(element).subscribe(
      (data: any) => {},
      (error) => {
        if (error.error.text === 'save_button_success') {
          this.eigerUser = false;
          this.toastr.success('Record successfully Updated');
          this.paginatedData = [];
          this.loadPortDetailsAndData();
        } else {
          this.toastr.error(ToasterMessages.Error);
        }
      }
    );
  }

  captureScreenshot(): void {
    const element = document.querySelector('.mapView') as HTMLElement;

    if (!element) {
      console.error('Map view element not found');
      return;
    }

    // Flash effect
    this.showFlash = true;
    setTimeout(() => (this.showFlash = false), 300);

    html2canvas(element, {
      useCORS: true,
      allowTaint: false,
      logging: false,
      backgroundColor: null,
      scale: 2,
    })
      .then((canvas: HTMLCanvasElement) => {
        const link = document.createElement('a');
        link.download = 'screenshot.png';
        link.href = canvas.toDataURL('image/png');
        link.click();

        this.showToast = true;
        setTimeout(() => (this.showToast = false), 2000);
      })
      .catch((err) => {
        console.error('Screenshot failed:', err);
      });
  }

  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
}
